if (!customElements.get('product-detail-drawers')) {
  customElements.define('product-detail-drawers', class ProductDetailDrawers extends HTMLElement {
    constructor() {
      super();
      this.activeTrigger = null;
      this.querySelectorAll('[data-product-drawer-open]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', () => this.open(trigger));
      });
      this.querySelectorAll('[data-product-drawer]').forEach((drawer) => {
        drawer.querySelector('[data-product-drawer-close]')?.addEventListener('click', () => drawer.close());
        drawer.addEventListener('click', (event) => {
          if (event.target === drawer) drawer.close();
        });
        drawer.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          drawer.close();
        });
        drawer.addEventListener('close', () => this.restoreFocus(drawer));
      });
    }

    open(trigger) {
      const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!drawer) return;
      this.activeTrigger = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      drawer.showModal();
      drawer.querySelector('[data-product-drawer-close]')?.focus();
    }

    restoreFocus(drawer) {
      const trigger = this.activeTrigger;
      if (!trigger || trigger.getAttribute('aria-controls') !== drawer.id) return;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
      this.activeTrigger = null;
    }
  });
}
